import Landing from '@/components/pages/Landing'
import Login from '@/components/pages/account/Login'
import Signup from '@/components/pages/account/Signup'
import ForgotPassword from '@/components/pages/account/ForgotPassword'
import ResetPassword from '@/components/pages/account/ResetPassword'

import { redirectIfLoggedIn } from './guard'

export default [
  {
    path: '/',
    name: 'landing',
    component: Landing,
    beforeEnter: redirectIfLoggedIn,
    meta: { fluidPage: true }
  },
  {
    path: '/account/login/',
    name: 'account-login',
    component: Login,
    beforeEnter: redirectIfLoggedIn,
    meta: { fluidPage: true }
  },
  {
    path: '/account/signup/',
    name: 'account-signup',
    component: Signup,
    beforeEnter: redirectIfLoggedIn,
    meta: { fluidPage: true }
  },
  {
    path: '/account/forgot-password/',
    name: 'account-forgot-password',
    component: ForgotPassword,
    beforeEnter: redirectIfLoggedIn,
    meta: { fluidPage: true }
  },
  {
    path: '/account/reset-password/:uid/:token/',
    name: 'account-reset-password',
    component: ResetPassword,
    beforeEnter: redirectIfLoggedIn,
    meta: { fluidPage: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/account.js